import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47ea2903"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "tz-dropdown" }
const _hoisted_2 = ["value", "disabled", "onKeydown"]
const _hoisted_3 = ["onClick", "onMouseover", "autofocus"]

import { Ref, ref, toRefs, watch, withDefaults } from 'vue'

  import { timeZones } from '@/utils/timezone'

  interface Props {
    input: string
    disabled?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    input: null,
    disabled: { type: Boolean, default: false }
  },
  emits: ['updateTimezone'],
  setup(__props: any, { emit }) {

const props = __props as { input: string, disabled: boolean }

  

  

  const { input, disabled } = toRefs(props)
  const timezone: Ref<string> = ref(props.input)
  const isOpen: Ref<boolean> = ref(false)
  const tzList: Ref<HTMLInputElement | null> = ref(null)
  const focusItemIndex: Ref<number> = ref(0)

  function matchTimezone(t: string): RegExpMatchArray | null {
    return t.toLowerCase().match(timezone.value.toLowerCase())
  }
  function onMouseOver(index: number) {
    focusItemIndex.value = index
  }
  function onUpdateTimezone(value: string) {
    timezone.value = value
    isOpen.value = false
    emit('updateTimezone', value)
  }
  function onEnter(event: Event & { target: HTMLInputElement }) {
    event.preventDefault()
    if (tzList.value?.firstElementChild?.innerHTML) {
      onUpdateTimezone(tzList.value?.firstElementChild?.innerHTML)
    }
  }
  function openDropdown(event: Event & { target: HTMLInputElement }) {
    event.preventDefault()
    isOpen.value = true
    timezone.value = event.target.value.trim()
  }

  watch(
    () => props.input,
    (value) => {
      timezone.value = value
    }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      class: "tz-dropdown-input",
      id: "timezone",
      name: "timezone",
      value: timezone.value,
      disabled: _unref(disabled),
      required: "",
      onKeydown: [
        _cache[0] || (_cache[0] = _withKeys(($event: any) => (onUpdateTimezone(_unref(input))), ["esc"])),
        _withKeys(onEnter, ["enter"])
      ],
      onInput: openDropdown
    }, null, 40, _hoisted_2),
    (isOpen.value)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "tz-dropdown-list",
          ref: (_value, _refs) => {
            _refs['tzList'] = _value
            tzList.value = _value
          }
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeZones).filter((t) => matchTimezone(t)), (tz, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: tz,
              class: _normalizeClass(["tz-dropdown-item", { focus: index === focusItemIndex.value }]),
              onClick: ($event: any) => (onUpdateTimezone(tz)),
              onMouseover: ($event: any) => (onMouseOver(index)),
              autofocus: index === focusItemIndex.value
            }, _toDisplayString(tz), 43, _hoisted_3))
          }), 128))
        ], 512))
      : _createCommentVNode("", true)
  ]))
}
}

})